<div class="modal-header blue">
  <h4 class="modal-title">Add Group Enrollments</h4>
  <a href="javascript:void(0)" class="modal-close-btn" (click)="close()"></a>
</div>

<div class="modal-body" [class.loading]="isLoading">
  <form [formGroup]="groupEnrollmentForm">
    <div class="form-row mb-3">
      <div class="col-6">
        <div class="input-label required">Payer</div>
        <ng-select
          [items]="groupEnrollmentPayers"
          placeholder="Enter Payer Name or Id"
          bindLabel="payerName"
          bindValue="neicId"
          appendTo="body"
          formControlName="payerId"
          [loading]="isPayerLoading"
          (change)="onPayerSelect($event)"
          (scrollToEnd)="onScrollToEnd()"
          [searchFn]="customSearchFn"
          (search)="onSearch($event)"
          (clear)="onPayerClear()"
          [class.is-invalid]="
            groupEnrollmentForm.get('payerId')?.touched &&
            groupEnrollmentForm.get('payerId')?.invalid
          "
        >
          <ng-template ng-label-tmp let-item="item">
            <div [title]="item.payerName">
              {{ item.neicId + ' - ' + item.name }}
            </div>
          </ng-template>
          <ng-template
            ng-option-tmp
            let-item="item"
            let-search="searchTerm"
            let-index="index"
          >
            <span>{{ item.neicId + ' - ' + item.name }}</span>
          </ng-template>
        </ng-select>
        <div
          class="invalid-feedback text-left"
          *ngIf="
            groupEnrollmentForm.get('payerId')?.invalid &&
            groupEnrollmentForm.get('payerId')?.touched
          "
        >
          <span *ngIf="groupEnrollmentForm.get('payerId')?.errors?.required"
            >This field is required</span
          >
        </div>
      </div>
    </div>

    <div class="form-row mb-3">
      <div class="col">
        <div class="input-label required mb-2">enrollment type</div>
        <div class="d-flex flex flex-wrap align-items-start">
          <checkbox
            *ngFor="let checkbox of groupEnrollmentTypeCheckboxes"
            class="mr-3"
            [inputClass]="
              checkbox.error ? 'invalid' : checkbox.saved ? 'success' : ''
            "
            [class.disabled]="checkbox.disabled"
            (change)="onEnrollmentTypeCheck($event, checkbox.value)"
          >
            {{ checkbox.label }}
          </checkbox>
        </div>
      </div>
    </div>

    <div class="form-row mb-3">
      <div class="col-8">
        <div class="input-label">Group Name</div>
        <input
          type="text"
          [disabled]="true"
          [value]="groupName"
          class="input"
        />
      </div>

      <div class="col-2">
        <div class="w-134px">
          <div class="input-label required">Group ID</div>
          <div class="group-ng-select-wrapper">
            <ng-select
              #groupSelect
              [items]="userGroups"
              placeholder="Enter Group Id"
              bindLabel="groupId"
              bindValue="groupId"
              appendTo="body"
              (change)="onGroupSelect($event)"
              (clear)="resetForm()"
              [class.is-invalid]="!isGroupSelected"
            >
              <ng-template ng-label-tmp let-item="item">
                <div [title]="item.groupId">
                  {{ item.groupId }}
                </div>
              </ng-template>
              <ng-template
                ng-option-tmp
                let-item="item"
                let-search="searchTerm"
                let-index="index"
              >
                <span>{{ item.groupId }}</span>
              </ng-template>
            </ng-select>
            <span class="fas fa-search search-icon"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="form-row mb-3">
      <div class="col-6">
        <div class="input-label required">NPI</div>

        <div class="input-wrap select">
          <select class="input" formControlName="npi">
            <option [value]="''" selected="selected" disabled>
              Select NPI
            </option>
            <option *ngFor="let npi of npiList" [value]="npi" title="{{ npi }}">
              {{ npi }}
            </option>
          </select>
        </div>

        <div
          class="invalid-feedback text-left"
          *ngIf="
            groupEnrollmentForm.get('npi')?.invalid &&
            groupEnrollmentForm.get('npi')?.touched
          "
        >
          <span *ngIf="groupEnrollmentForm.get('npi')?.errors?.required"
            >This field is required</span
          >
          <span *ngIf="groupEnrollmentForm.get('npi')?.errors?.maxlength">
            Maximum length is
            {{
              groupEnrollmentForm.get('npi')?.errors?.maxlength[
                'requiredLength'
              ]
            }}
            characters.
          </span>
        </div>
      </div>

      <div class="col-6">
        <div class="input-label required">tax id</div>
        <div class="input-wrap select">
          <select class="input" formControlName="taxId">
            <option [value]="''" selected="selected" disabled>
              Select Tax Id
            </option>
            <option
              *ngFor="let taxId of taxIdList"
              [value]="taxId"
              title="{{ taxId }}"
            >
              {{ taxId }}
            </option>
          </select>
        </div>

        <div
          class="invalid-feedback text-left"
          *ngIf="
            groupEnrollmentForm.get('taxId')?.invalid &&
            groupEnrollmentForm.get('taxId')?.touched
          "
        >
          <span *ngIf="groupEnrollmentForm.get('taxId')?.errors?.required"
            >This field is required</span
          >
          <span *ngIf="groupEnrollmentForm.get('taxId')?.errors?.maxlength">
            Maximum length is
            {{
              groupEnrollmentForm.get('taxId')?.errors?.maxlength[
                'requiredLength'
              ]
            }}
            characters.
          </span>
        </div>
      </div>
    </div>

    <div class="form-row mb-3">
      <div class="col-6">
        <div class="input-label required">status</div>
        <div class="input-wrap select">
          <select class="input" formControlName="enrollmentStatus">
            <option [value]="''" selected="selected" disabled>
              Select Status
            </option>
            <option
              *ngFor="let status of statuses"
              [value]="status.code"
              title="{{ status.description }}"
            >
              {{ status.description }}
            </option>
          </select>
        </div>

        <div
          class="invalid-feedback d-block text-left"
          *ngIf="
            groupEnrollmentForm.get('enrollmentStatus')?.invalid &&
            groupEnrollmentForm.get('enrollmentStatus')?.touched
          "
        >
          <span
            *ngIf="
              groupEnrollmentForm.get('enrollmentStatus')?.errors?.required
            "
            >This field is required</span
          >
        </div>
      </div>
      <div class="col-6">
        <div class="w-134px">
          <div class="input-label">Followup Date</div>
          <div class="w-100">
            <datepicker formControlName="followUpDate"></datepicker>
          </div>
        </div>
      </div>
    </div>

    <div class="form-row mb-3">
      <div class="col-6">
        <div>
          <div class="input-label">Case Number</div>
          <input
            type="text"
            formControlName="caseNumber"
            placeholder="Enter Case Number"
            class="input"
            [class.is-invalid]="
              groupEnrollmentForm.get('caseNumber')?.touched &&
              groupEnrollmentForm.get('caseNumber')?.invalid
            "
          />
        </div>

        <div
          class="invalid-feedback text-left"
          *ngIf="
            groupEnrollmentForm.get('caseNumber')?.invalid &&
            groupEnrollmentForm.get('caseNumber')?.touched
          "
        >
          <span
            *ngIf="groupEnrollmentForm.get('caseNumber')?.errors?.maxLength"
          >
            Maximum length is
            {{
              groupEnrollmentForm.get('caseNumber')?.errors?.maxlength[
                'requiredLength'
              ]
            }}
            characters.
          </span>
        </div>
      </div>

      <div class="col-6">
        <div>
          <div class="input-label required">Processor Id</div>
          <input
            type="text"
            formControlName="processorId"
            placeholder="Enter Processor Id"
            class="input"
            [class.is-invalid]="
              groupEnrollmentForm.get('processorId')?.touched &&
              groupEnrollmentForm.get('processorId')?.invalid
            "
          />
        </div>

        <div
          class="invalid-feedback text-left"
          *ngIf="
            groupEnrollmentForm.get('processorId')?.invalid &&
            groupEnrollmentForm.get('processorId')?.touched
          "
        >
          <span *ngIf="groupEnrollmentForm.get('processorId')?.errors?.required"
            >This field is required</span
          >
        </div>
      </div>
    </div>

    <div class="form-row mb-3">
      <div class="col-6">
        <div class="input-label">Notes</div>

        <div class="input-wrap">
          <textarea
            rows="7"
            placeholder="Enter Notes"
            formControlName="actionNotes"
          ></textarea>
        </div>
        <div
          class="invalid-feedback text-left"
          *ngIf="
            groupEnrollmentForm.get('actionNotes')?.invalid &&
            groupEnrollmentForm.get('actionNotes')?.touched
          "
        >
          <span
            *ngIf="groupEnrollmentForm.get('actionNotes')?.errors?.maxLength"
          >
            Maximum length is
            {{
              groupEnrollmentForm.get('actionNotes')?.errors?.maxlength[
                'requiredLength'
              ]
            }}
            characters.
          </span>
        </div>
      </div>

      <div class="col-6">
        <div class="input-label">Message</div>

        <div class="input-wrap">
          <textarea
            rows="7"
            [class.is-invalid]="
              groupEnrollmentForm.get('message')?.touched &&
              groupEnrollmentForm.get('message')?.invalid
            "
            placeholder="Enter Message"
            formControlName="message"
          ></textarea>
        </div>
        <div
          class="invalid-feedback text-left"
          *ngIf="
            groupEnrollmentForm.get('message')?.invalid &&
            groupEnrollmentForm.get('message')?.touched
          "
        >
          <span *ngIf="groupEnrollmentForm.get('message')?.errors?.maxLength">
            Maximum length is
            {{
              groupEnrollmentForm.get('message')?.errors?.maxlength[
                'requiredLength'
              ]
            }}
            characters.
          </span>
        </div>
      </div>
    </div>

    <div class="mb-3" *ngIf="selectedPayer && documents">
      <div class="input-label">documents</div>

      <div class="standart-card-outline">
        <div
          class="standart-card-outline-body"
          [class.documents]="documents.length"
        >
          <ng-container *ngIf="documents?.length; else empty">
            <div class="file" *ngFor="let item of documents">
              <div class="file-icon">
                <i class="fas fa-file-csv"></i>
              </div>
              <a href="javascript:void(0);" (click)="download({ item })"
                ><span class="file-name">{{ item }}</span></a
              >
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div *ngIf="selectedPayer || selectedGraphPayer">
      <div class="standart-page-title mb-3">Payer Selection</div>

      <div class="form-row">
        <div class="col">
          <div class="d-flex flex-wrap">
            <div class="mb-3 w-50">
              <label> id </label>
              <div class="input-text">
                {{
                  (selectedPayer ? selectedPayer.id : selectedGraphPayer?.id) ||
                    'N/A'
                }}
              </div>
            </div>

            <div class="mb-3 w-50">
              <label> Enrollment Type </label>
              <div class="input-text">
                <ng-container *ngIf="selectedPayer">
                  {{ selectedPayer.enrollmentType || 'N/A' }}
                </ng-container>

                <ng-container *ngIf="selectedGraphPayer">
                  <!-- PROFFESIONAL should be here -->
                  {{
                    selectedGraphPayer.institutionalEnrollment === 'Y'
                      ? 'Institutional'
                      : ''
                  }}
                  {{ selectedGraphPayer.eraEnrollment === 'Y' ? 'ERA' : '' }}
                  {{
                    selectedGraphPayer.claimStatusEnrollment === 'Y'
                      ? 'Claim Status'
                      : ''
                  }}
                  {{
                    selectedGraphPayer.eligibilityEnrollment === 'Y'
                      ? 'Eligibility'
                      : ''
                  }}
                </ng-container>
              </div>
            </div>

            <div class="mb-3 w-50">
              <label>
                {{ selectedPayer ? 'scId' : 'neicId' }}
              </label>
              <div class="input-text">
                {{
                  (selectedPayer
                    ? selectedPayer.scId
                    : selectedGraphPayer?.neicId) || 'N/A'
                }}
              </div>
            </div>

            <div class="mb-3 w-50">
              <label> Processor Id </label>
              <div class="input-text">
                {{
                  selectedPayer
                    ? selectedPayer.processorId
                    : selectedGraphPayer?.processorId || 'N/A'
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button
    type="submit"
    class="button ml-auto w-80px"
    [disabled]="
      groupEnrollmentForm.invalid ||
      isLoading ||
      this.selectedEnrollmentTypes.length === 0
    "
    (click)="onSave()"
  >
    Save
  </button>
</div>

<ng-template #empty>
  <empty-state></empty-state>
</ng-template>
